var _circle, _circle2, _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgBybit1(props) {
  var _id7 = useUniqueInlineId();
  var _id6 = useUniqueInlineId();
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1920,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id6, ")")
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id7, ")")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "M0 0h1080v1920H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id2, ")"),
    d: "M921 1260h225v772H921z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id3, ")"),
    d: "M-115 166H45v388h-160z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id4, ")"),
    d: "M963-50h60v388h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id5, ")"),
    d: "M141 1408h188v568H141z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1151,
    cy: 1413,
    r: 640,
    fill: "#fff",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -100,
    cy: 1672,
    r: 640,
    fill: "#fff",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 540,
    y1: 0,
    x2: 540,
    y2: 1920,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#2E2E2E"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 1033.5,
    y1: 1260,
    x2: 1033.5,
    y2: 2032,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA943"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: -35,
    y1: 166,
    x2: -35,
    y2: 554,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA943"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 993,
    y1: -50,
    x2: 993,
    y2: 338,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA943"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 235,
    y1: 1408,
    x2: 235,
    y2: 1976,
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA943"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1080v1920H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1080v1920H0z"
  })))));
}
export default SvgBybit1;